<template>
	<SuiSelectListButton
		:aria-label="
			$t('user_assign_select_user_label', {
				name: user.name,
			})
		"
		@click="$emit('click')"
	>
		<SuiAvatar
			size="x-small"
			show-border
			:url="user.profilePicture?.mini"
			:initials="user.initials || ''"
			:color="user.hslColor || ''"
		/>
		<p>
			{{ user.name }}
		</p>
	</SuiSelectListButton>
</template>

<script setup lang="ts">
import { type ResourcePlanningUserSelectQuery } from '@/generated/graphql';
import { SuiSelectListButton, SuiAvatar } from '@developers/scoro-ui';

export type ResourcePlanningUserSelectButtonProps = {
	user: ResourcePlanningUserSelectQuery['UsersList'][0];
};

defineProps<ResourcePlanningUserSelectButtonProps>();

defineEmits(['click']);
</script>
